import { AfterViewInit, Component, HostListener, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as feather from "feather-icons";
import * as moment from "moment";
import { Feedback } from "src/app/common/models/feedback";
import { Plan } from "src/app/common/models/plan";
import { User } from "src/app/common/models/user";
import { FeedbackService } from "src/app/common/services/feedback.service";
import { PdfGenerationService } from "src/app/common/services/pdf-generation.service";
import { SharedService } from "src/app/common/services/shared.service";
import { UserService } from "src/app/common/services/user.service";
import { PdfResponse } from "../../common/models/pdfResponse";
import { saveAs } from 'file-saver';
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { MemberProfile } from "../../common/models/profile";
import { forkJoin, Observable } from "rxjs";
import { forEach } from "lodash";

@Component({
    selector: 'app-dialog-submit-plan',
    templateUrl: 'dialog-submit-plan.component.html',
    styleUrls: ['dialog-submit-plan.component.css'],
    providers: [FeedbackService],
    standalone: false
})
  export class DialogSubmitPlanComponent implements AfterViewInit, OnInit {

    feedback: Feedback = {UserId: null, ProcessComments: "", ToolComments: "", ProcessRating: null, ToolRating: null};
    submitButtonPressed = false;
    submitted = false;
    plan: Plan;
    user: User;
    profile: MemberProfile = {
      member: {
        given_nm: '',
        last_nm: '',
        email_no: '',
        member_id: ''
      },
      member_call: {
        call_dt: '',
        province_cl: ''
      },
      primary_location: {
        company_nm: '',
        city_nm: ''
      }
    };
    submittedDate: string;
    toolRating: number;
    processRating: number;
    isFeedbackValid = false;
    isSendingPdfEmail = false;
    isDownloadingPdf = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: {userId: string, isEditing: boolean}, public dialogRef: MatDialogRef<DialogSubmitPlanComponent>, private feedbackService: FeedbackService, private sharedService: SharedService, private userService: UserService, private pdfService: PdfGenerationService, private _snackBar: MatSnackBar)
    {
      dialogRef.disableClose = true;
      this.feedback.UserId = data.userId;
    }

    @HostListener('window:keyup.esc') onKeyUp() {
      this.dialogRef.close();
    }

    ngOnInit(){
      this.userService.user().subscribe({
        next: (u) => {
          this.user = u;
          this.sharedService.submittedPlan$.subscribe({
            next: (p) => {
              this.plan = p
              if(p.LastEditDate)
                this.submittedDate = moment.utc(p.LastEditDate).local().format("LLL");
              else
                this.submittedDate = moment.utc(p.SubmissionDate).local().format("LLL");
            }
          })
        }
      });
      this.userService.profile().subscribe({next: (profile) => this.profile = profile});
    }

    ngAfterViewInit(): void {
        feather.replace();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    submitFeedback() {
      this.submitButtonPressed = true;
      if(this.isFeedbackValid){
        this.feedback.ToolRating = this.toolRating;
        this.feedback.ProcessRating = this.processRating
        this.feedbackService.postFeedback(this.feedback).subscribe(() => {
          this.submitted = true;
        });
      }
    }

    downloadPdf(isSimplified?: boolean) {
      this.isDownloadingPdf = true;

      const generatePlanPdfObservables: Observable<PdfResponse>[] = [];

      if (isSimplified == undefined) {
        generatePlanPdfObservables.push(this.pdfService.generatePlanPdf(this.plan.Id, true));
        generatePlanPdfObservables.push(this.pdfService.generatePlanPdf(this.plan.Id, false));
      } else {
        generatePlanPdfObservables.push(this.pdfService.generatePlanPdf(this.plan.Id, isSimplified))
      }

      forkJoin(generatePlanPdfObservables).subscribe({
        next: (responses: PdfResponse[]) => {
          forEach(responses, response => saveAs(response.data, response.fileName))
        },
        error: () => {
          this.openSnackbarError("Unable to generate PDF(s).");
        },
        complete: () => {
          this.isDownloadingPdf = false;
        }
      });
    }

    emailPdf(isSimplified?: boolean) {
      this.isSendingPdfEmail = true;
      this.pdfService.emailPlanPdf(this.plan.Id, isSimplified).subscribe({
        error: () => {
          this.openSnackbarError("Unable to generate PDF.");
        },
        complete: () => {
          this.isSendingPdfEmail = false;
        }
      });
    }

    onFeedbackChange() {
      this.isFeedbackValid = !!this.toolRating || !!this.processRating || this.feedback.ToolComments.length > 0 || this.feedback.ProcessComments.length > 0;
    }

    openSnackbarError(message: string) {
      this._snackBar.openFromComponent(SnackbarComponent, {
        data: message, panelClass: 'snackbar-error'
      });
    }

    openSnackbarInfo(message: string) {
      this._snackBar.openFromComponent(SnackbarComponent, {
        data: message, panelClass: 'snackbar', duration: 2000
      });
    }

  }
